declare var angular: any;

import { TimerComponent } from './../../../../../../app/training/shared/timer/timer.component';
import { RecordAudioComponent } from './../../../../../../app/training/shared/record-audio/record-audio.component';

import { UsersListComponent } from './../../../../../../app/training/shared/users-list/users-list.component';
import { LerobertHomeComponent } from './../../../../../../app/home/lerobert/home/home.component';
import { LeRobertHome2Component } from './../../../../../../app/home/lerobert/home2/home2.component';
import { InstitutionsListComponent } from './../../../../../../app/training/shared/institutions-list/institutions-list.component';

import { ManualCorrectionComponent } from './../../../../../../app/teacher/manual-correction/manual-correction.component';

import { downgradeComponent } from '@angular/upgrade/static';

angular
  .module('UserHomeControllers', [])

  .controller('HomeCtrl', [
    '$scope',
    '$location',
    'api',
    'blog',
    'UtilitiesService',
    async function($scope, $location, api, blog, UtilitiesService) {
      api.sync(api.getStats, function(data) {
        $scope.stats = data;
      });

      blog.getArticles().then(function(articles) {
        $scope.articles = articles;
      });

      $scope.goLesson = function(lesson) {
        $location.url('/lesson/' + lesson);
      };

      let activation_codes: any[] = await api.getActivationsCode();
      let hasCustomCode = activation_codes.find(
        code => code.code === 'NATH-TOEIC-30'
      );
      if (hasCustomCode) {
        $scope.book2 = true;
      }

      $scope.openSwitchLevelDialog = () => {
        console.log('openSwitchLevelDialog', $scope.main.me);
        UtilitiesService.getSwitchLevelDialog(
          $scope.main.me.profile.id,
          $scope.main.me.profile.level
        ).subscribe(res => {
          if (res) {
            api.sync(api.me);
            window.alert(
              'Nous allons recharger la page pour appliquer le changement de niveau'
            );
            window.location.reload();
          }
        });
      };
    }
  ])

  .filter('parseDuration', function() {
    return function(duration) {
      var hours: any = Math.floor(duration / 3600);
      if (hours < 10) hours = '0' + hours;
      var minutes: any = Math.floor((duration % 3600) / 60);
      if (minutes < 10) minutes = '0' + minutes;
      return hours + 'h' + minutes;
    };
  })

  .directive(
    'polylearnUsersList',
    downgradeComponent({ component: UsersListComponent })
  )

  .directive(
    'polylearnInstitutionsList',
    downgradeComponent({ component: InstitutionsListComponent })
  )

  .directive(
    'polylearnTimer',
    downgradeComponent({ component: TimerComponent })
  )

  .directive(
    'polylearnRecordAudio',
    downgradeComponent({ component: RecordAudioComponent })
  )

  .directive(
    'polylearnLerobertHome',
    downgradeComponent({ component: LerobertHomeComponent })
  )

  .directive(
    'polylearnLerobertHome2',
    downgradeComponent({ component: LeRobertHome2Component })
  )

  .directive(
    'polylearnManualCorrections',
    downgradeComponent({ component: ManualCorrectionComponent })
  )

  .component('removeAccount', {
    templateUrl: '/ng1/www/modules/global/account/html/removeAccount.html',
    controller: [
      '$scope',
      'api',
      '$location',
      '$mdToast',
      function($scope, api, $location, $mdToast) {
        $scope.removeAccount = async function() {
          let isConfirmed = window.confirm(
            '⭕️ Êtes-vous sûr de vouloir supprimer votre compte ?'
          );

          if (isConfirmed) {
            await api.deleteMyUser();
            api.logout();

            $mdToast.show(
              $mdToast
                .simple()
                .textContent('Votre compte a bien été supprimé')
                .position('bottom right')
                .hideDelay(6000)
            );
          }
        };
      }
    ]
  })

  /*
  .component('supportView', {

    template: `
    Yolo
    {{$ctrl.support | json}}
    {{main.exam | json}}
      <div ng-if="$ctrl.support.part" ng-include="'/ng1/www/modules/exam/'+ $ctrl.exam +'/support/'+ $ctrl.support.part+'.html'">
      </div>
    `,
    bindings: {
      support: '<',
      exam: '<',
    },
    /*
    controller: ['$scope', 'api', '$location', '$mdToast', function ($scope, api, $location, $mdToast) {

    }]
  })
  */

  .component('emailEdit', {
    templateUrl: '/ng1/www/modules/user/index/html/change_email.html',
    controller: [
      '$scope',
      'api',
      '$location',
      'navbar',
      function($scope, api, $location, navbar) {
        let email = api?.data?.me?.user?.email;
        $scope.email = email;

        $scope.changeEmail = function() {
          if ($scope.email !== $scope.email2) {
            $scope.error = 'Vos deux addresses ne sont pas identiques';
            return;
          }

          // Hack to avoid call api and get error because addresse already exists
          if ($scope.email === email) {
            $scope.success = 'Votre adresse email a été mis à jour';
            $scope.loading = false;
            return;
          }

          api.changeEmail($scope.email).then(
            function() {
              $scope.success = 'Votre adresse email a été mis à jour';
              api.me().then(function() {
                // $location.url('/');
              });
            },
            function(error) {
              $scope.error = error.data.title + ' -  ' + error.data.description;
            }
          );
        };
      }
    ]
  });
